import * as React from "react";
import { SVGProps } from "react";
const SvgTime = (props: SVGProps<SVGSVGElement>) => <svg width={65} height={65} viewBox="0 0 65 65" {...props}><g fill="none" fillRule="evenodd" stroke="currentColor" strokeWidth={3}><circle cx={32.5} cy={32.5} r={31} /><path d="M30.5 12v21.5H44" /></g></svg>;
export default SvgTime;